import React from "react";
import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

import { Cell } from "./layouts/Grid";

import theme from "../../styles/theme";

const {
	breakPoints: { mobileFirstScreenQuery },
} = theme;

const OverflowCell = styled(Cell)`
	img {
		width: 100%;
		object-fit: contain;
	}

	${mobileFirstScreenQuery.large} {
		width: 50vw;
		position: relative;
		left: 0%;
		margin-left: ${(props) => (props.flipX ? "0vw" : "-15vw")};
		margin-right: -50vw;
		background: ${(props) => props.backgroundColor};

		img {
			padding: 20px 0;
			margin-left: ${(props) => (props.flipX ? "5%" : "-5%")};
		}
	}

	${mobileFirstScreenQuery.doubleXLarge} {
		margin-left: ${(props) => (props.flipX ? "0vw" : "-30vw")};
	}
`;

const OverflowScreenshot = ({ backgroundColor, image, flipX }) => {
	return (
		<OverflowCell
			flipX={flipX}
			span={6}
			start={flipX ? 7 : 1}
			className="vertical-center"
			backgroundColor={backgroundColor}
		>
			<GatsbyImage image={image} />
		</OverflowCell>
	);
};

export default OverflowScreenshot;
